<template>
  <div class="query-container">
    <div class="query-container__search">
      <div class="query-container__search__box">
        <h4>
          <i class="el-icon-d-arrow-right"></i> 筛选条件
        </h4>
        <div class="query-container__search__form">
          <slot name="searchContent"></slot>
          <div slot="searchButton" class="query-container__search__form__button">
            <el-button
            :loading="loading"
            size="small"
            icon="el-icon-search"
            @click="handleSearch"
          >筛选</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
            <el-button v-if="isShowExport" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="query-container__content">
      <slot name="listContent"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QueryContainer',
  model: {
    prop: 'loading',
    event: 'searchLoading'
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isShowExport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleSearch() {
      this.$emit('searchLoading', true)
      this.$emit('search')
    },
    reset() {
      this.$emit('reset')
    },
    handleExport() {
      this.$emit('export')
    }
  }
}
</script>
<style scoped>
.query-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 20px;
  display: flex;
  box-sizing: border-box;
}

.query-container__search {
  flex-shrink: 0;
  overflow: auto;

}

.query-container__search__box {
  width: 260px;
  padding: 20px;
  background: #fff;
  box-shadow: rgb(206, 211, 217) 0px 1px 1px 0px;
}

.query-container__search__form {
  padding-top: 10px;
  padding-bottom: 10px;
}

.query-container__search__form__button {
  margin-top: 20px
}

.query-container__search__form__button .el-button {
  display: inline-block;
  vertical-align: middle;
}

.query-container__search h4 {
  border-bottom: 1px solid #e5e5e5;
  font-size: 14px;
  font-weight: 700;
  height: 20px;
  padding: 0 0 10px;
  line-height: 20px;
}

.query-container__content {
  margin-left: 20px;
  flex: 1;
  overflow: auto;
}
</style>